import React, { useState } from "react";
import { FormControlLabel, Checkbox, Box } from "@mui/material";

const AgreementCheckboxField = ({
  schema,
  idSchema,
  formData,
  onChange,
  rawErrors = [],
  uiSchema = {},
}) => {
  const { title, description } = schema;
  const uiDescription = uiSchema["ui:description"];
  const fieldId = idSchema.$id;

  const [touched, setTouched] = useState(false);

  const handleChange = (event) => {
    const checked = event.target.checked;
    setTouched(true);
    onChange(checked ? true : undefined);
  };

  const handleNAChange = (event) => {
    const checked = event.target.checked;
    setTouched(true);
    onChange(checked ? false : undefined);
  };

  return (
    <Box mb={0}>
      {description && (
        <Box mt={1} mb={1}>
          {typeof description === "string" ? (
            <div>{description}</div>
          ) : (
            description
          )}
        </Box>
      )}

      {!description && uiDescription && (
        <Box mt={1} mb={1}>
          {uiDescription}
        </Box>
      )}
      <Box display="flex" flexDirection="row" gap={10}>
        <FormControlLabel
          control={
            <Checkbox
              id={`${fieldId}-agree`}
              checked={formData === true}
              onChange={handleChange}
              onBlur={() => setTouched(true)}
            />
          }
          label={title}
        />

        {fieldId === "root_insurance_insuranceTerm" && (
          <FormControlLabel
            control={
              <Checkbox
                id={`${fieldId}-na`}
                checked={formData === false}
                onChange={handleNAChange}
                onBlur={() => setTouched(true)}
              />
            }
            label="Not Applicable"
          />
        )}
      </Box>
    </Box>
  );
};

export default AgreementCheckboxField;
